module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-news-headImg"
  }, [_c('el-carousel', {
    attrs: {
      "height": "150px"
    }
  }, _vm._l((_vm.newsData), function(headImgItem, index) {
    return _c('el-carousel-item', {
      key: index
    }, [_c('img', {
      staticClass: "image-item",
      attrs: {
        "src": headImgItem.image
      },
      on: {
        "click": function($event) {
          _vm.window.open(headImgItem.link)
        }
      }
    })])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-28e1000f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/business/newsTemplate/HeadImg.vue
// module id = 748
// module chunks = 1